<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-tint card-start-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      <div class="card-data">
        <p v-if="node.data.isPromotionalChecked && node.data.promotional" key="1" class="text-center mb-0 postback_title">
          <i class="fas fa-clock"></i> {{ node.data.promotionalText }}
        </p>

        <p v-if="node.data.isNonPromotionalChecked && node.data.nonPromotional" key="2" class="text-center mb-0 postback_title">
          <i class="fas fa-sun"></i> {{ node.data.nonPromotionalText }}
        </p>
      </div>

      <div class="card-sockets">
        <div class="output text-right float-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
          <div class="output-title">{{output.name}}</div>
          <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
        </div>
        <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
          <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
          <div class="input-title">{{input.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'

import { templateComponentMethods } from '../../utils/functions'

export default {
  name: 'SequenceSingleTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  methods: {
    ...templateComponentMethods,
  },
}
</script>

<style scoped>
  .card-content { font-weight: 400;font-size:12px;}
  .card-sockets { padding: 5px 0 !important;}
  .card-envelope-icon { font-size:13px;}
  .postback_title {
    background-color: #f6f4f4 !important;
    border-radius: 7px;
    padding: 0px 10px;
    text-transform:capitalize;
  }
  .label_ids {
    margin-bottom: 0;
    font-size: 13px;
    color: #6e6e6e;
  }
  .sequence_ids {
    border-top: .5px solid #6e6e6e;
    margin-bottom: 0;
    font-size: 13px;
    color: #6e6e6e;
  }
</style>